// extracted by mini-css-extract-plugin
export var measureBox = "_bq-0";